import React, { useEffect, useState } from 'react';
import ReusableTable from '../../components/ReusableTable';
import CreateButton from '../../components/CreateButton';
import EditButton from '../../components/EditButton';
import DeleteButton from '../../components/DeleteButton';
import ViewButton from '../../components/ViewButton';
import {
  getParametros,
  createParametro,
  editParametro,
  deleteParametro
} from '../../services/Admin/parametroService';
import {
  getDetalleByParametroId,
  createDetalle,
  editDetalle,
  deleteDetalle
} from '../../services/Admin/detalleParametroService';
import {
  getSedeDepartamentos,
  createSedeDepartamento,
  editSedeDepartamento,
  deleteSedeDepartamento
} from '../../services/Admin/sedeDepartamentoService';

const columns = [
  { key: 'id_parametro', label: 'ID' },
  { key: 'nombre', label: 'Nombre' },
  { key: 'descripcion', label: 'Descripción' }
];

const formConfig = [
  { name: 'nombre', label: 'Nombre', type: 'text' },
  { name: 'descripcion', label: 'Descripción', type: 'text' }
];

const detalleColumns = [
  { key: 'id_detaparametro', label: 'ID' },
  { key: 'nombre', label: 'Nombre' },
  { key: 'valor', label: 'Valor' },
  { key: 'descripcion', label: 'Descripción' },
  { key: 'estado', label: 'Estado' }
];

const detalleFormConfig = [
  { name: 'nombre', label: 'Nombre', type: 'text' },
  { name: 'valor', label: 'Valor', type: 'text' },
  { name: 'descripcion', label: 'Descripción', type: 'text' },
  { name: 'estado', label: 'Estado', type: 'number' }
];

const ParametrosPage = () => {
  const [data, setData] = useState([]);
  const [reload, setReload] = useState(false);
  const [sedeDepData, setSedeDepData] = useState([]);
  const [sedeDepReload, setSedeDepReload] = useState(false);

  useEffect(() => {
    getParametros()
      .then(setData)
      .catch(() => setData([]));
  }, [reload]);

  useEffect(() => {
    getSedeDepartamentos()
      .then(setSedeDepData)
      .catch(() => setSedeDepData([]));
  }, [sedeDepReload]);

  const handleCreate = async (values, onDone) => {
    const success = await createParametro(values);
    if (success) setReload(r => !r);
    onDone(success);
  };

  const handleEdit = async (id, values, onDone) => {
    const success = await editParametro(id, values);
    if (success) setReload(r => !r);
    onDone(success);
  };

  const handleDelete = async (id, onDone) => {
    const success = await deleteParametro(id);
    if (success) setReload(r => !r);
    onDone(success);
  };

  const actionRender = row => (
    <>
      <EditButton
        item={row}
        formConfig={formConfig}
        onEdit={(values, onDone) => handleEdit(row.id_parametro, values, onDone)}
      />
      <ViewButton
        onView={() => getDetalleByParametroId(row.id_parametro)}
        columns={detalleColumns}
        formConfig={detalleFormConfig}
        onCreate={createDetalle(row.id_parametro)}
        onEdit={editDetalle()}
        onDelete={deleteDetalle()}
      />
      <DeleteButton
        item={row}
        onDelete={onDone => handleDelete(row.id_parametro, onDone)}
      />
    </>
  );

  return (
    <div>
      <div style={{ overflow: 'hidden' }}>
        <CreateButton formConfig={formConfig} onCreate={handleCreate} />
      </div>
      <ReusableTable
        data={data}
        columns={columns}
        actionRender={actionRender}
      />

      <h3 style={{ marginTop: 24 }}>Sede Departamento</h3>
      <div style={{ overflow: 'hidden' }}>
        <CreateButton
          formConfig={[
            { name: 'detaparametroId', label: 'ID Departamento (detaparametroId)', type: 'number' },
            { name: 'nombre', label: 'Nombre', type: 'text' },
            { name: 'valor', label: 'Valor', type: 'text' },
            { name: 'descripcion', label: 'Descripción', type: 'text' }
          ]}
          onCreate={async (values, onDone) => {
            const success = await createSedeDepartamento(values);
            if (success) setSedeDepReload(r => !r);
            onDone(success);
          }}
        />
      </div>
      <ReusableTable
        data={sedeDepData}
                 columns={[
           { key: 'compositeId', label: 'ID', formatter: (v, row) => `${row.idSede}/${row.detaparametroId}` },
           { key: 'nombreSede', label: 'Nombre Sede' },
           { key: 'nombre', label: 'Nombre' },
           { key: 'estado', label: 'Estado' }
         ]}
        actionRender={row => (
          <>
            <EditButton
              item={row}
              formConfig={[
                { name: 'nombre', label: 'Nombre', type: 'text' },
                { name: 'valor', label: 'Valor', type: 'text' },
                { name: 'descripcion', label: 'Descripción', type: 'text' },
                { name: 'estado', label: 'Estado', type: 'number' }
              ]}
              onEdit={async (values, onDone) => {
                const success = await editSedeDepartamento(row.idSede, row.detaparametroId, values);
                if (success) setSedeDepReload(r => !r);
                onDone(success);
              }}
            />
            <DeleteButton
              item={{ nombre: row.nombre }}
              onDelete={async onDone => {
                const success = await deleteSedeDepartamento(row.idSede, row.detaparametroId);
                if (success) setSedeDepReload(r => !r);
                onDone(success);
              }}
            />
          </>
        )}
      />
    </div>
  );
};

export default ParametrosPage;